import { OutcomeDataResponse } from './AttendingOutcomeListMapper.types'

class AttendingOutcomeListMapper {
  toDomain(outcome: OutcomeDataResponse) {
    return {
      id: outcome?.idDesfecho,
      key: outcome?.valor,
      value: outcome?.descricao,
    }
  }
}

export default new AttendingOutcomeListMapper()
